class ProductCardQuickShop extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    this.init();
  }
  init() {
    this.querySelectorAll('[js-add-to-cart]').forEach((t) => {
      t.addEventListener('click', this.addToCart.bind(this, t));
    });
    const t = this.querySelector('[js-quick-shop]');
    t?.addEventListener('click', this.showOptions.bind(this));
  }
  async addToCart(t) {
    const i = t.getAttribute('data-variant-id');

    try {
      if (!window.theme?.addToCart) {
        // Fallback: Try using shopifyUtils directly
        if (window.shopifyUtils?.addToCart) {
          await window.shopifyUtils.addToCart({
            items: [{ id: i, quantity: 1 }]
          });

          this.classList.remove('active');

          const basketElement = document.querySelector('.c-header__basket');
          if (basketElement) {
            basketElement.click();
          }
          return;
        }

        console.error('No cart methods available');
        return;
      }

      await window.theme.addToCart([{ id: i, quantity: 1 }]);
      
      this.classList.remove('active');

    } catch (error) {
      console.error('Error in addToCart:', error);
    }
  }
  /* showOptions() {
    document.querySelectorAll('product-card-quick-shop').forEach(item => item.classList.remove('active')); // Hide all other quick shop options
    this.classList.add('active');
  } */
  showOptions() {
    document.querySelectorAll('product-card-quick-shop').forEach(item => item.classList.remove('active')); // Hide all other quick shop options
    
    // Ensure the first line is completely executed before the second line
    requestAnimationFrame(() => {
      this.classList.add('active');
    });
  }
}
customElements.get('product-card-quick-shop') ||
  customElements.define('product-card-quick-shop', ProductCardQuickShop);
